import { render, staticRenderFns } from "./FieldProvidersByMunicipalityId.vue?vue&type=template&id=7b4d180c&scoped=true&"
import script from "./FieldProvidersByMunicipalityId.vue?vue&type=script&lang=js&"
export * from "./FieldProvidersByMunicipalityId.vue?vue&type=script&lang=js&"
import style0 from "./FieldProvidersByMunicipalityId.vue?vue&type=style&index=0&id=7b4d180c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d180c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4d180c')) {
      api.createRecord('7b4d180c', component.options)
    } else {
      api.reload('7b4d180c', component.options)
    }
    module.hot.accept("./FieldProvidersByMunicipalityId.vue?vue&type=template&id=7b4d180c&scoped=true&", function () {
      api.rerender('7b4d180c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldProvidersByMunicipalityId.vue"
export default component.exports